<script>


export default {
    name: 'course-item',
    props : {
        item: {
            type: Object,
        },
        index: {
            type: Number,
        }
    },
    data() {
        return {
        }
    },

    methods: {
        getLocations() {
            return this.item.courseLocation;
        },

        calcCapacity() {
            return (this.item.courseCapacity === 1) ? 'green' : 'grey';
        },

        bgColor() {
            return (this.index % 2 ===0)  ? 'odd' : 'even';
        },

        formatPrice(price) {
            if (price === null ) {
                return '';
            }

            price = Number.isInteger(price) ? price : parseInt(price);

            let  formatted =  price.toLocaleString('nb-NO') ;

            return formatted+ ' kr';
        }
    }
}

</script>

<template>
    <div class="course-item" :class="bgColor">
        <div class="course-item__cell course-item__large">
            <a :href="item.link" class="link link--accent">{{ item.title }}</a>
        </div>
        <div class="course-item__cell course-item__medium">{{ getLocations() }}</div>
        <div class="course-item__cell course-item__medium">{{ item.startDateLocalized ?? '' }}</div>
        <div class="course-item__cell course-item__small">{{ item.duration }} dager</div>
        <div class="course-item__cell course-item__medium">{{ formatPrice(item.coursePrice) }} </div>
        <div class="course-item__cell course-item__small">
            <span class="course-capacity" :class="calcCapacity()"></span>
        </div>
        <div class="course-item__cell course-item__action">
            <a class="button__link button__link--light" :href="item.link">
            <span class="svgIcon mr-3">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 12.5 22.8" style="enable-background:new 0 0 12.5 22.8;" xml:space="preserve">
                    <path class="st0" d="M0,0v22.8l11.4-11.4L0,0z"></path></svg>
            </span>
            <span>Les mer</span>
            </a>
        </div>
    </div>
</template>
